'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UICard = require('UIComponents/card/UICard');

var _UICard2 = _interopRequireDefault(_UICard);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _color = require('MeetingsBase/utils/color');

var _colors = require('MeetingsBase/constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'ColoredCard',

  propTypes: {
    className: _react.PropTypes.string,
    children: _react.PropTypes.node.isRequired,
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired,
    isFetchingPublicGlobalBranding: _react.PropTypes.bool.isRequired
  },

  getPrimaryColorToUse: function getPrimaryColorToUse() {
    var _props = this.props,
        isFetchingPublicGlobalBranding = _props.isFetchingPublicGlobalBranding,
        primaryColor = _props.branding.primaryColor;


    return isFetchingPublicGlobalBranding ? _colors.DEFAULT_COLOR : primaryColor;
  },
  getTextColorToUse: function getTextColorToUse() {
    var _props2 = this.props,
        isFetchingPublicGlobalBranding = _props2.isFetchingPublicGlobalBranding,
        primaryColor = _props2.branding.primaryColor;


    return isFetchingPublicGlobalBranding ? null : (0, _color.getTextColor)(primaryColor);
  },
  getStyle: function getStyle() {
    var primaryColorToUse = this.getPrimaryColorToUse();
    var textColorToUse = this.getTextColorToUse();

    return {
      backgroundColor: primaryColorToUse,
      backgroundImage: 'none',
      color: textColorToUse
    };
  },
  render: function render() {
    var _props3 = this.props,
        className = _props3.className,
        children = _props3.children;


    return _react2.default.createElement(
      _UICard2.default,
      {
        className: className + ' m-bottom-0 p-all-0',
        style: this.getStyle()
      },
      _react2.default.createElement(
        _UIFlex2.default,
        { direction: 'column', align: 'center', justify: 'start' },
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/decorative/ColoredCard.js
// module id = 395
// module chunks = 0